export const CLICKED_BACK_BUTTON = 'clicked-back-button';
export const CLICKED_DISCARD_CHANGES_BUTTTON = 'clicked-discard-changes-button';
export const CLICKED_PUBLISH_BUTTON = 'clicked-publish-button';
export const CLICKED_UNDO_BUTTON = 'clicked-undo-button';
export const CLICKED_REDO_BUTTON = 'clicked-redo-button';
export const CLICKED_REVISIONS_BUTTON = 'clicked-revisions-button';
export const SUBMIT_PATAGONIA_FEEDBACK = 'submit-patagonia-feedback';
export const RESET_THEME_SETTINGS_FORM = 'reset-theme-settings-form';
export const RESET_THEME_FIELD = 'reset-theme-field';
export const RESET_INHERITING_THEME_FIELD = 'reset-inheriting-theme-field';
export const UNLINK_INHERITING_THEME_FIELD = 'unlink-inheriting-theme-field';